import PropTypes from 'prop-types';

const surveyListBatchActions = {
  EDIT: 'Edit',
  DUPLICATE: 'Duplicate',
  ARCHIVE: 'Archive',
  UNARCHIVE: 'Unarchive',
  DELETE: 'Delete',
};

export const SurveyListBatchActionsPropTypes = PropTypes.arrayOf(
  PropTypes.oneOf(Object.values(surveyListBatchActions)),
);

export default surveyListBatchActions;
